import { useNavigate } from "react-router-dom";
import { Alert, Button, Col, Row, Spinner } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiAccountTieOutline, mdiCardRemoveOutline } from "@mdi/js";
import { useInfiniteQuery } from "react-query";

import { PageSize, SkeletonCount } from "../../config/defines";
import { getUsuariosListar, getGetUsuariosListarQueryKey } from "../../config/swagger";

import InfiniteScroll from "../../components/InfiniteScroll";
import UsuariosCard from "../../components/UsuariosCard";
import Layout from "../../components/Layout";

export default function Usuarios() {
	const navigate = useNavigate();

	const query = useInfiniteQuery(getGetUsuariosListarQueryKey({ offset: 0, limit: PageSize }), ({ pageParam = 0 }) => getUsuariosListar({ offset: pageParam * PageSize, limit: PageSize }), {
		getNextPageParam: (lastPage, allPages) => (lastPage.Data?.length === PageSize ? allPages.length : null),
	});

	return (
		<Layout>
			<h5 className="mt-4 mb-4 d-flex align-items-center fw-light">
				<Icon path={mdiAccountTieOutline} size={1} className="me-2" /> Usuários
				{query.isRefetching && <Spinner size="sm" className="ms-1" variant="secondary" />}
				<div className="float-right ms-auto" style={{ marginTop: -10, marginBottom: -10 }}>
					<Button
						variant="primary"
						className="rounded-3 shadow-sm"
						onClick={() => {
							navigate("/usuarioFormulario");
						}}
					>
						Cadastrar
					</Button>
				</div>
			</h5>

			<Row className="mb-4">
				{query.isLoading &&
					Array.from({ length: Number(SkeletonCount) }, (_, index) => {
						return (
							<Col md={12} key={index}>
								<UsuariosCard skeleton />
							</Col>
						);
					})}
				{!query.isLoading && query.isError && (
					<Col md={12}>
						<Alert variant="secondary" className="text-center">
							Problema na operação. Tente novamente mais tarde
						</Alert>
					</Col>
				)}
				{!query.isLoading && query.data?.pages[0].Data && query.data.pages[0].Data.length === 0 && (
					<Col md={12}>
						<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
							<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
							Nenhum registro encontrado
						</Alert>
					</Col>
				)}
				{!query.isLoading &&
					query.data?.pages.map((dataPage, dataPageIndex) => {
						return (
							dataPage?.Data &&
							dataPage?.Data.length >= 1 &&
							dataPage?.Data.map((item) => {
								return (
									<Col md={12} key={item.id}>
										<UsuariosCard data={item} />
									</Col>
								);
							})
						);
					})}
				<Col md={12} className="text-center">
					<InfiniteScroll
						more={query.hasNextPage}
						loading={query.isFetchingNextPage}
						loader={<UsuariosCard skeleton />}
						load={() => {
							query.fetchNextPage();
						}}
					/>
				</Col>
			</Row>
		</Layout>
	);
}
